var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('k-text',{staticClass:"font-weight-medium",attrs:{"text":_vm.label}})}
var staticRenderFns = []

export { render, staticRenderFns }